/**
 * Returns a market code that can be used when fetching data from Depict.
 */
export const getDepictMarketCode = (countryCode: string) => {
    const depictCountryToPricelist: Record<string, string> = {
        at: "at",
        au: "au",
        be: "be",
        bg: "bg",
        ca: "ca",
        ch: "ch",
        cy: "cy",
        cz: "cz",
        de: "de",
        dk: "dk",
        ee: "ee",
        es: "es",
        fi: "fi",
        fr: "fr",
        gb: "gb",
        gi: "gi",
        gr: "gr",
        hr: "hr",
        hu: "hu",
        ie: "ie",
        it: "it",
        jp: "jp",
        lt: "lt",
        lu: "lu",
        lv: "lv",
        mt: "mt",
        nl: "nl",
        no: "no",
        nz: "nz",
        pl: "pl",
        pt: "pt",
        ro: "ro",
        se: "se",
        si: "si",
        sk: "sk",
        us: "us"
    }

    return depictCountryToPricelist[countryCode.toLowerCase()] || "de"
}
